import { Route, Routes } from 'react-router-dom'

import ArtworkReviewer from './screens/ArtworkReviewer'
import MediaReviewer from './screens/MediaReviewer'

const CampaignRoutes = () => (
  <Routes>
    <Route path="/artworkReviewer" element={<ArtworkReviewer />} />
    <Route path="/mediaReviewer" element={<MediaReviewer />} />
  </Routes>
)

export default CampaignRoutes
